module.exports = __webpack_public_path__ + "media/images/icon_signup-bb801f278356acf8e3ac978d0ccb2a65.svg";